<script setup>
import { ref } from "vue";

const props = defineProps({
  method: {
    type: Function,
    required: true,
  },
  args: {
    default: null,
    required: false,
  },
  buttonStyle: {
    type: String,
    default: "button",
  },
});

const loading = ref(false);
const complete = ref(false);
const error = ref(false);


async function run(args) {
  loading.value = true;

  try {
    const response = await props.method(args);

    loading.value = false;
    complete.value = true;

    setTimeout(() => {
      complete.value = false;
    }, 2500);

  } catch (err) {
    loading.value = false;
    error.value = true;

    setTimeout(() => {
      error.value = false;
    }, 2000);
  }
}
</script>

<template>
  <div @click="run(args)" :class="[{ loading }, { complete }, { error }, buttonStyle]">
    <div class="button__loading">
      <svg-vue icon="loader"></svg-vue>
    </div>
    <div class="button__complete">
      <svg-vue icon="check"></svg-vue>
    </div>
    <div class="button__error">
      <svg-vue icon="error"></svg-vue>
    </div>
    <div class="button__text">
      <slot></slot>
    </div>
  </div>
</template>
